import { useEffect, useRef, useState } from 'react';
// import { Exercises } from "../../../constants/constants";
import { ENV } from '@config/env';
import { SERVER_BASE_URL } from '../../../constants/domain';
import ProgressBar from './progress-bar';
import tw from 'twin.macro';

const CreatorSection = ({
  playVideo,
  progress,
  setProgress,
  setCreatorDuration,
  setIsPlayingFeedback,
  setCanPlay,
  movementName,
  videoSrc,
}) => {
  const [isPlayingFirst, setIsPlayingFirst] = useState(false);
  const [lastTime, setLLastTime] = useState(null);
  const videoPlayerRef = useRef(null);

  const handleTimeUpdate = () => {
    //  this code for calculate steps
    if (playVideo?.creator_video && videoPlayerRef.current) {
      const currentTime = videoPlayerRef.current.currentTime;
      const duration = playVideo.creator_video.to - playVideo.creator_video.from;
      const Time = currentTime - lastTime;
      if (duration > 0 && progress <= 100) {
        const progressPercentage = (100 / duration) * Time;
        // if (progress >= 96) {
        //   setProgress(100);
        // }
        // if (
        //   movementName.toLocaleLowerCase() ===
        //   Exercises.spongebob.toLocaleLowerCase()
        // ) {
        //   setProgress((prev) =>
        //     prev >= 80 ? 100 : Math.min(prev + progressPercentage, 100)
        //   );
        // } else {
        setProgress(prev => Math.min(prev + progressPercentage, 100));
        // }
      }
      setLLastTime(videoPlayerRef.current.currentTime);
    }
  };

  useEffect(() => {
    if (videoPlayerRef.current && playVideo?.creator_video) {
      setCreatorDuration(playVideo?.creator_video?.to - playVideo?.creator_video?.from);
      if (videoPlayerRef.current?.currentTime >= playVideo?.creator_video?.to) {
        videoPlayerRef.current.pause();
        setIsPlayingFirst(false);
      } else {
        videoPlayerRef.current.play();
        setIsPlayingFeedback(false);
        setIsPlayingFirst(true);
      }
    }
  }, [videoPlayerRef.current?.currentTime, playVideo?.creator_video?.to, playVideo?.creator_video]);

  useEffect(() => {
    if (videoPlayerRef.current && playVideo?.creator_video?.from) {
      videoPlayerRef.current.currentTime = playVideo?.creator_video?.from;
    }
  }, [playVideo?.creator_video?.from, playVideo?.creator_video?.speed]);

  useEffect(() => {
    if (videoPlayerRef.current && playVideo?.creator_video?.speed) {
      videoPlayerRef.current.playbackRate = playVideo?.creator_video?.speed;
    }
  }, [playVideo?.creator_video?.speed]);

  useEffect(() => {
    if (!lastTime && videoPlayerRef?.current?.currentTime) {
      setLLastTime(videoPlayerRef.current.currentTime);
    }
  }, [lastTime, videoPlayerRef?.current?.currentTime]);

  return (
    <div tw="relative h-[inherit]">
      <video
        preload="metadata"
        // Without playsinline iOS Safari opens its own fullscreen player on play.
        playsInline
        webkit-playsinline="true"
        disablePictureInPicture
        onTimeUpdate={handleTimeUpdate}
        ref={videoPlayerRef}
        style={{
          filter: !isPlayingFirst ? 'grayscale(1)' : 'grayscale(0)',
        }}
        tw="w-full h-[99%] object-fill"
        // css={
        //   movementName.toLocaleLowerCase() !=
        //   Exercises.shutdown.toLocaleLowerCase()
        //     ? tw`scale-x-[-1]  rounded-br-[20px] rounded-tr-[20px]`
        //     : tw` rounded-bl-[20px] rounded-tl-[20px]`
        // }
        src={ENV.isLocal ? `/public/${videoSrc}` : SERVER_BASE_URL + videoSrc}
        onCanPlay={() => {
          setCanPlay(true);
        }}
        muted
      />
      <ProgressBar backGroundBar="#0B834F" level={progress} />
    </div>
  );
};

export default CreatorSection;
